export default "__VITE_ASSET__j5Xt_ZfW__"